/** Form logic */
var $forms = ['#aad-quiz', '.update-subtask.validate', '#rcp_password_form', '.contact-preferences'];
var errClass = 'has-error'; // Errors show on fields before any input is made
var validationBody = {
  ignore: ['input[type=button], input[type=submit], button[type=button]'],
  errorElement: 'div',
  errorPlacement: function (error, element) {
    $(element).parents('.field-wrap').append(error);
  },
  highlight: function (element, errorClass, validClass) {
    $(element).parents('.field-wrap').addClass(errClass);
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).parents('.field-wrap').removeClass(errClass);
  }
};

$.each($forms, function(index, form) {
  var $form = $(form);

  var $fieldsToValidate = $form.find('.required');

  if ($form.length > 0) {
    $form.validate(validationBody);

    /** Add validation to the password fields */
    var isLoginform = $form.attr('id') == 'rcp_login_form' ? true : false,
      passwordFieldId = $form.find('input[data-validate="user_password"]');

    if ($(passwordFieldId).length > 0) {
      $(passwordFieldId).rules('add', {
        required: true,
        minlength: 8,
        maxlength: 30,
        strongPassword: isLoginform,
        messages: {
          strongPassword: isLoginform ? 'Password is required' : 'Password must contain at least one number, lowercase and uppercase.'
        }
      });

      $form.find('input[data-validate="confirm_user_password"]').rules('add', {
        required: true,
        equalTo: passwordFieldId,
        messages: {
          equalTo: 'Please enter the same password again'
        }
      });

      $.validator.addMethod('strongPassword', function (value, element) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]?)[A-Za-z\d@$!%*?&]{8,}$/.test(value);
      });

      $(passwordFieldId).on('paste input', function () {
        $(this).valid();
      });
    }

    $form.find('[type="submit"]').on('click', function () {
      $fieldsToValidate.valid();
    });

    /** Add email validation */
    $form.find('input[data-validate="user_email"]').rules('add', {
      email: true
    });

    /** Phone validation */
    $form.find('input[data-validate="phone_number"]').each(function () {
      $(this).rules('add', {
        telephoneNumber: true
      });
    });

    $.validator.addMethod(
      'telephoneNumber',
      function (phone_number, element) {
        phone_number = phone_number.replace(/\s+/g, '');
  
        return this.optional(element) || (phone_number.length > 9 && phone_number.match(/^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/));
      },
      'Please specify a valid phone number'
    );

    /** Postcode validation */
    $form.find('input[name="postcode"]').each(function () {
      $(this).rules('add', {
        postcode: true
      });
    });

    $.validator.addMethod(
      'postcode',
      function (value, element) {
        return checkPostCode(value);
      },
      'Please specify a valid postcode'
    );

    /** Remove whitespace on paste for phone numbers and emails */
    $form.find('input[data-validate="user_email"]').on('paste keyup blur', function () {
      var val = $(this).val();
      val = val.trim();

      $(this).val(val);
      $(this).valid();
    });

    $form.find('input[data-validate="phone_number"]').on('paste blur', function () {
      var val = $(this).val();
      val = val.trim();

      $(this).val(val);
      $(this).valid();
    });

    /** Check form validity on each change to ensure the submit is enabled again */
    $form.find('input, textarea').on('keyup change blur', function (event) {
      checkFormValidity(event.target);
    });

    $form.find('input[data-validate="radio"]').on('change', function (event) {
      checkFormValidity(event.target);
    });

    /**
     * Slightly ugly if statement but we need to trick the validation
     * plugin into always enabling the submit button.
     *
     * Internally it does additional checking on submit and disables
     * the button - but doesn't show the issues. So we have to run the
     * checkForm() and then always set the submit as enabled regardless
     */
    function checkFormValidity(target) {
      if ($form.validate().checkForm()) {
        $(target).closest('.quiz-section').find('[type="submit"]').prop('disabled', false);
      } else {
        $(target).closest('.quiz-section').find('[type="submit"]').prop('disabled', true);
      }
    }
  }
});